<template>
  <div class='tablepage'>
    <Table border stripe :columns="columns" size='default' ref="selection" @on-drag-drop='onDragDrop'
      @on-row-click='rowclick' :draggable='isdrag' @on-selection-change='selectTable' :data="tableData">
      <template slot-scope="{ row, index }" slot="action">
        <span class='do' @click="show(index, row)">编辑</span>
        <!-- <Icon type="md-settings" @click="show(index,row)"></Icon> -->
      </template>
    </Table>
    <Page :total="totalNum" :current="curPage" show-total @on-change='getpage' @on-page-size-change='getChangepage'
      :page-size-opts='pagesizeopt' show-sizer class='pageClass' style='position:relative' />
  </div>
</template>

<script>
import uitls from '../utils/getSchoolData'
export default {
  name: 'tablePage',
  data () {
    return {
      tableData: [],
      totalNum: 0,
      curPage: 1,
      columns: [],
      curSchoolid: -1,
      itemid: '',
      length: 10,
      pagesizeopt: [10, 20, 40, 80, 100]
    }
  },
  mounted () {

    var userInfo = JSON.parse(localStorage.getItem('inchUserinfo'))
    this.curSchoolid = userInfo.schoolid
    var data = this.queryData[1]
    data.map(function (val, index) {
      // if(['content','title','notice','name'].indexOf(val['key'])>-1){
      // 	val['render'] = (h,params) => {
      // 		return   h('strong',decodeURIComponent(params.row[val['key']]))
      // 	}
      // }
      if (['classList'].indexOf(val['key']) > -1) {
        val['render'] = (h, params) => {
          var classlist = params.row.classList
          var list = ''
          for (var i = 0; i < classlist.length; i++) {
            if (list == '') {
              list += classlist[i]['name']
            } else {
              list += classlist[i]['name'] + '，'
            }
          }
          return h('span', list)
        }
      }
      if (['location'].indexOf(val['key']) > -1) {
        val['render'] = (h, params) => {
          var classlist = params.row.classList
          var list = ''
          for (var i = 0; i < classlist.length; i++) {
            if (list == '') {
              list += classlist[i]['name']
            } else {
              list += classlist[i]['name'] + '，'
            }
          }
          return h('span', list)
        }
      }

      if (['begintime', 'endtime', 'starttime', 'addtime', 'edittime', 'showtime', 'createTime', 'updateTime', 'rectime', 'backtime', 'pubtime'].indexOf(val['key']) > -1) {
        val['render'] = (h, params) => {
          var time = params.row[val['key']]

          if (time != null && typeof (time) == 'string') {
            if (time.indexOf('.0') > -1) {
              time = time.split('.0')[0]
            }

            var year = new Date().getFullYear()

            if (time.indexOf(year) > -1) {
              time = time.split(year + '-')[1]
            }

            return h('span', time)
          } else if (typeof (time) == 'number') {
            var date = new Date(time);
            var Y = date.getFullYear() + '-';
            var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';

            var D = date.getDate() + ' ';
            D = D > 9 ? D : '0' + D
            var h1 = date.getHours();
            h1 = h1 > 9 ? h1 : '0' + h1
            h1 += ':'
            var m = date.getMinutes();
            m = m > 9 ? m : '0' + m
            var s = date.getSeconds();
            s = s > 9 ? s : '0' + s
            if (Y == date.getFullYear() + '-') {
              return h('span', M + D + h1 + m)
            } else {
              return h('span', Y + M + D + h1 + m)
            }

          } else {
            return h('span', '')
          }
        }
      }
    })

    this.columns = data
    this.getData()
  },
  watch: {
    randomrow (newval, oldval) {
      this.show(0, this.emitrow)
    },
    issearch (newval, oldval) {
      if (this.searchParam.itemid == '' || this.searchParam.itemid) {
        var _curGuid = this.searchParam.itemid
        var _id = localStorage.getItem('curItemid')
        this.columns = this.queryData[1]
        if (_curGuid = _id) {
          this.curPage = 1
        }

      } else {
        this.curPage = 1

      }

      //
      this.getData()
    },
    searchParam (newval, oldval) {

      if (newval != oldval) {

        this.searchData(newval)
      }
    },
    // isdrag(newval,oldval){
    //   if(newval==true){

    //   }else{

    //   }
    // }
  },
  props: {
    randomrow: {
      type: Number,
      default: -1
    },
    emitrow: {
      type: Object,
      default: function () {
        return {}
      }
    },
    queryData: {
      default: {}
    },
    isdrag: {
      type: Boolean,
      default: false
    },
    searchParam: {
      type: Object,
      default: function () {
        return {}
      }
    },
    issearch: {
      default: false
    },
    extradata: {
      default: 0
    }
  },
  methods: {

    selectTable (a, b) {
      this.$emit('selectLcd', a)
    },
    getData (draw, params) {
      if (this.queryData[0] == '') {
        return false
      }

      var that = this
      var params = params || this.searchParam
      params['length'] = this.length
      params['pageno'] = draw || this.curPage || 1
      // params['start'] = (draw-1)*10 || (this.curPage -1)*10 ||  0
      // params['draw'] =   draw  ||  1
      // params['start'] = (draw-1)*10 ||   0

      if (this.queryData[0].indexOf('score/getQueryList.do') > -1) {
        if (this.queryData[0].indexOf('ismounted=1') > -1) {
          var queryData = that.$route.query
          var examtype = queryData.examtype
          if (examtype) {
            that.queryData[0] = 'score/getQueryList.do?examtype=' + examtype + '&schoolid=' + this.curSchoolid
          }

        }
      }

      this.axios.get(this.queryData[0], { params: params }).then(res => {

        var back = res.data
        if (that.queryData[0] == 'coursePoint/getTeacherPointData.do') {
          back.map(function (val, index) {
            val['sort'] = Number(params['pageno'] - 1) * 10 + Number(val['sort'])
          })
        }
        that.totalNum = res.recordsFiltered

        if (that.queryData[2]) {
          if (that.queryData[2]['type'] == 1) {
            that.tableData = back.filter(function (val, index) {


              if (val[that.queryData[2]['filterTa']].indexOf(that.queryData[2]['filterRowData']) < 0) {
                return val
              }

            })

          } else if (that.queryData[2]['type'] == 2) {
            that.tableData = back.filter(function (val, index) {


              if (val[that.queryData[2]['filterTa']].indexOf(that.queryData[2]['filterRowData']) > -1) {
                return val
              }

            })
          } else {
            var tableData = back.filter(function (val, index) {


              if (val[that.queryData[2]['filterTa']].indexOf(that.queryData[2]['filterRowData'][0]) > -1) {
                return val
              }

            })

            var tableDatas = back.filter(function (val, index) {
              if (val[that.queryData[2]['filterTa']].indexOf(that.queryData[2]['filterRowData'][1]) > -1) {
                return val
              }

            })
            that.tableData = tableData.concat(tableDatas)
          }

        } else {
          that.tableData = back
        }

        that.$emit('extradata', res.totalAount)
      })
    },
    rowclick (a, b, c) {
      this.$emit('rowData', a)
    },
    onDragDrop (first, end) {
      // this.tipsFlag = true
      var that = this


      var tableData = JSON.parse(JSON.stringify(this.tableData))
      var startguid = tableData[first]['t_i_guid'] || tableData[first]['guid']
      var endguid = tableData[end]['t_i_guid'] || tableData[end]['guid']
      if (first > end) {
        tableData.splice(end, 0, tableData[first])
        tableData.splice(Number(first) + 1, 1)
      } else {
        tableData.splice(end + 1, 0, tableData[first])
        tableData.splice(Number(first), 1)
      }
      that.tableData = tableData

      if (this.queryData[0].indexOf('dic/getQueryList?sort=999') > -1) {
        that.axios.post('dic/moveToPosition', { currentId: startguid, targetId: endguid, pid: 7777 }).then(res => {
          that.$Message.success(res.msg)
        })
      } else {
        console.log()
        var newitemid = that.searchParam['fid'] == that.searchParam['itemid'] ? that.searchParam['itemid'] : that.searchParam['fid'] + '_' + that.searchParam['itemid']
        that.axios.post('news/moveToPosition', { currentId: startguid, targetId: endguid, itemid: newitemid }).then(res => {
          that.$Message.success(res.msg)
        })
      }

    },
    searchData (param) {
      var that = this
      if (param['schoolid'] == -1) {
        param['schoolid'] = this.curSchoolid
      }
      this.axios.get(this.queryData[0], { params: param }).then(res => {

        var back = res.data

        if (this.queryData[0] == 'coursePoint/getTeacherPointData.do') {
          back.map(function (val, index) {
            val['sort'] = param['draw'] * 10 + Number(val['sort'])
          })
        }

        that.totalNum = res.recordsFiltered
        that.tableData = back
      })
    },
    getChangepage (a, b, c) {

      this.length = a
      this.getData(1)
    },
    getpage (val) {

      this.curPage = val
      this.getData(val)
    },
    show (index, row) {

      if (row.flag == 0) {

        this.$emit('removeModal', row.guid, row, this.curPage)
      } else {
        this.$emit('smodal', row.guid, row, this.curPage)
      }

    }
  }
}
</script>
<style scoped>
.tablepage .pageClass {
  text-align: right;
  margin-top: 30px;
}

.do {
  display: inline-block;
  width: 50px;
  height: 25px;
  background: #2db7f5;
  border-radius: 6px;
  text-align: center;
  line-height: 25px;
  color: #fff;

  font-size: 12px;
  cursor: pointer;
}

.do+.do {
  margin-left: 14px;
}

>>>.ivu-table-wrapper {
  overflow: visible !important
}
</style>
